import React, { useEffect, useState } from 'react';

import css from './SuccessBanner.module.css';

const COLLAPSE_MS = 300;
export const SUCCESS_BANNER_AUTO_HIDE_MS = 6000;

const SuccessBanner = ({
  show,
  onDismiss,
  title,
  message,
  autoHideMs = SUCCESS_BANNER_AUTO_HIDE_MS,
}) => {
  const [visible, setVisible] = useState(show);
  const [collapsing, setCollapsing] = useState(false);

  useEffect(() => {
    if (!show) {
      setVisible(false);
      setCollapsing(false);
      return undefined;
    }

    setVisible(true);
    setCollapsing(false);

    const hideTimer = window.setTimeout(() => {
      setCollapsing(true);
    }, autoHideMs);

    return () => window.clearTimeout(hideTimer);
  }, [show, autoHideMs]);

  useEffect(() => {
    if (!collapsing) return undefined;

    const collapseTimer = window.setTimeout(() => {
      setVisible(false);
      setCollapsing(false);
      if (onDismiss) onDismiss();
    }, COLLAPSE_MS);

    return () => window.clearTimeout(collapseTimer);
  }, [collapsing, onDismiss]);

  if (!visible) return null;

  return (
    <div
      className={[css.banner, collapsing && css.collapsing].filter(Boolean).join(' ')}
      role="status"
      aria-live="polite"
    >
      <span className={css.icon} aria-hidden="true">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="12" fill="currentColor" />
          <path
            d="M7 12.5l3 3 7-7"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
      <div className={css.content}>
        <p className={css.title}>{title}</p>
        {message && <p className={css.message}>{message}</p>}
      </div>
    </div>
  );
};

export default SuccessBanner;
